<template>
  <div class="share-header">
    <!-- 左侧：Logo + 文件名 -->
    <div class="header-left">
      <img src="@/assets/img/logo-title.png" class="logo" height="20" alt="Logo" @click="goHome" />
      <div v-if="fileName" class="file-name-wrapper">
        <img v-if="fileIcon" :src="fileIcon" class="file-icon" alt="" />
        <ellipsis-text :text="fileName" class="file-name" />
        <span v-if="version" class="version-tag">{{ version }}</span>
      </div>
    </div>

    <!-- 右侧：工具栏 + 用户信息 -->
    <div class="header-right">
      <!-- 图标容器 -->
      <div class="icon-container">
        <el-tooltip class="icon-item" effect="dark" content="广小二" placement="bottom">
          <img src="@/assets/img/icon_guangxiaoer.svg" width="20" @click="openRobot" alt="" />
        </el-tooltip>
        <el-tooltip class="icon-item" effect="dark" content="反馈" placement="bottom">
          <img src="@/assets/img/icon_feedback.svg" width="20" @click="toFeedback" alt="" />
        </el-tooltip>
        <el-tooltip class="icon-item" effect="dark" content="帮助文档" placement="bottom">
          <img src="@/assets/img/icon_help.svg" width="20" @click="toHelp" alt="" />
        </el-tooltip>
      </div>

      <!-- 用户信息 -->
      <div v-if="user && user.id" ref="headerCollapse" class="user-info">
        <div class="user-brief-info gjw-flex-container gjw-flex-row gjw-flex-verti-center">
          <img :src="$hosts.static(user.avatar)" />
          <span class="user-name" :title="user.name">{{ user.name }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <Collapse>
          <template>
            <gjw-collapse>
              <ul
                v-show="showCollapse"
                ref="menu"
                class="user-menu gjw-shadow-small"
              >
                <li class="user-info-menu-item">
                  <img :src="$hosts.static(user.avatar)" />
                  <span class="user-name" :title="user.name">{{ user.name }}</span>
                  <span class="user-mobile" :title="user.mobile">手机号：{{ user.mobile }}</span>
                </li>
                <div class="user-action">
                  <li class="user-menu-item">
                    <a @click="userInfo()" target="_blank">
                      <i class="el-icon-setting"></i>
                      <span>个人信息</span>
                    </a>
                  </li>
                  <li class="user-menu-item" @click="logout()">
                    <svg
                      t="1721801713004"
                      class="icon svg-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#495F70"
                      p-id="1527"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M885.952 537.472l0.64-0.704 0.64-0.896 0.448-0.64 0.704-0.96 0.384-0.512a38.912 38.912 0 0 0 0.64-1.024l0.384-0.576a38.4 38.4 0 0 0 0.64-1.024c0-0.192 0.192-0.384 0.256-0.64a38.208 38.208 0 0 0 0.512-0.96l0.384-0.64 0.384-0.96 0.384-0.832a38.4 38.4 0 0 0 0.32-0.832l0.32-0.896 0.256-0.768a40.704 40.704 0 0 0 0.384-1.088l0.192-0.64a36.736 36.736 0 0 0 0.256-1.152l0.192-0.64a36.992 36.992 0 0 0 0.256-1.152c0-0.256 0-0.448 0.128-0.64l0.192-1.216 0.064-0.704 0.128-1.152 0.064-0.96 0.064-0.896a38.4 38.4 0 0 0 0-3.776v-0.896l-0.128-0.96-0.128-1.088-0.064-0.768-0.192-1.216-0.128-0.64-0.256-1.152-0.192-0.64-0.256-1.152-0.192-0.64-0.384-1.088-0.256-0.704-0.32-0.96-0.32-0.832-0.384-0.832-0.384-0.896-0.384-0.64a39.488 39.488 0 0 0-0.512-1.024l-0.32-0.64a34.56 34.56 0 0 0-0.64-1.024c0-0.192-0.192-0.384-0.256-0.512l-0.64-1.088c-0.192-0.128-0.32-0.32-0.384-0.512l-0.768-0.96-0.448-0.64-0.64-0.832-0.64-0.768-0.64-0.64-1.28-1.344-177.6-177.664a38.208 38.208 0 0 0-54.08 54.016l112.384 112.384H431.04a38.208 38.208 0 1 0 0 76.48h333.696l-112.384 112.384a38.208 38.208 0 0 0 54.08 54.08l177.6-177.664 1.28-1.344 0.64-0.64z"
                        p-id="1528"
                      ></path>
                      <path
                        d="M435.008 864.64H191.36V161.28h243.584a42.624 42.624 0 0 0 0-85.248H148.8a42.624 42.624 0 0 0-42.624 42.624v788.608c0 23.552 19.072 42.624 42.624 42.624h286.208a42.624 42.624 0 0 0 0-85.184z"
                        p-id="1529"
                      ></path>
                    </svg>
                    <span>退出登录</span>
                  </li>
                </div>
              </ul>
            </gjw-collapse>
          </template>
        </Collapse>
      </div>

      <!-- 未登录状态 -->
      <div v-else class="login-btn-wrapper">
        <el-button type="text" size="small" @click="handleLogin">登录 / 注册</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Collapse from '@/components/common/Collapse'
import GjwCollapse from '@/components/lib/GjwCollapse'
import EllipsisText from '@/views/file/components/EllipsisText.vue'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import openUrlMixin from '@/mixins/openUrlMixin'

export default {
  name: 'ShareHeader',
  mixins: [checkLoginMixin, openUrlMixin],
  components: { EllipsisText, Collapse, GjwCollapse },
  props: {
    fileName: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    },
    fileIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showCollapse: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      platform: 'platform',
      getConfig: 'staticConfig/getConfig',
    })
  },
  watch: {
    // 监听用户登录状态变化
    'user.id': {
      handler(newVal, oldVal) {
        // 从未登录变为已登录时，添加事件监听器
        if (newVal && !oldVal) {
          this.$nextTick(() => {
            this.addCollapseListeners()
          })
        }
      }
    }
  },
  async created() {
    const isLogin = await this.checkLogin(null)
    if (isLogin) {
      const res = await this.$api.user.userInfoRefresh()
      res && await this.loadUserInfo()
      // 用户信息加载后，等待 DOM 更新再添加事件监听器
      this.$nextTick(() => {
        this.addCollapseListeners()
      })
    }
  },
  mounted() {
    // 如果已登录，添加事件监听器
    this.addCollapseListeners()
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      logoutUserInfo: 'user/logout',
    }),
    // 添加下拉菜单事件监听器
    addCollapseListeners() {
      const collapse = this.$refs.headerCollapse
      if (collapse && !collapse._hasListener) {
        // 标记已添加监听器，避免重复添加
        collapse._hasListener = true

        collapse.addEventListener(
          'mouseenter',
          () => {
            this.showCollapse = true
          },
          false
        )
        collapse.addEventListener(
          'mouseleave',
          () => {
            this.showCollapse = false
          },
          false
        )
        this.$once('hook:beforeDestroy', () => {
          if (collapse) {
            collapse.removeEventListener('mouseenter', () => {
              this.showCollapse = true
            })
            collapse.removeEventListener('mouseleave', () => {
              this.showCollapse = false
            })
            collapse._hasListener = false
          }
        })
      }
    },
    goHome() {
      this.$router.push({ name: 'Index' })
    },
    handleLogin() {
      this.$emit('login')
    },
    async openRobot() {
      if (this.user.name) {
        const data = await this.$api.user.getLoginToken()
        document.querySelector('#gr-window iframe').contentWindow.postMessage({
          type: 'plugin-sso-login-token',
          loginToken: data
        }, '*')
      }
      window.GlodonRobotJsSDK.show()
    },
    toFeedback() {
      const url = `${process.env.VUE_APP_GJW_PORTAL_URL}/feedback?source=TeamSpace`
      this.openUrl(url)
    },
    toHelp() {
      const urls = this.getConfig('linkUrls') || {}
      const url = urls.helpUrl
      if (!url) { return }
      this.openUrl(url)
    },
    async userInfo() {
      if (this.platform === 'web') {
        window.open(
          `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user`,
          '_blank'
        )
      } else {
        const url = await this.$api.user.ssoUrl({ dest: `${process.env.VUE_APP_GJW_PORTAL_URL}/private#/user` })
        await this.$desktopClient.NavigateToBrowser(url)
      }
    },
    async logout() {
      const host = process.env.VUE_APP_CURRENT_MODE === 'local' ? process.env.VUE_APP_PROJECT_HOST : process.env.VUE_APP_GJW_PORTAL_URL
      const dest = `${host}${process.env.VUE_APP_SUB_URL}#/signin`
      await this.logoutUserInfo({ dest: dest, platform: this.platform })
      // 通知父组件退出登录
      this.$emit('logout')
      // 刷新页面
      location.reload()
    },
  },
}
</script>

<style lang="less" scoped>
.share-header {
  height: 40px;
  line-height: 40px;
  border: 1px solid #d2d9e3;
  background: #f7f9fa;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;

    .logo {
      cursor: pointer;
      flex-shrink: 0;
    }

    .file-name-wrapper {
      margin-left: 20px;
      display: flex;
      align-items: center;
      min-width: 0;
      flex: 1;

      .file-icon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        flex-shrink: 0;
        vertical-align: sub;
      }

      .file-name {
        font-size: 14px;
        color: #495f70;
        min-width: 0;
      }

      .version-tag {
        display: block;
        height: 18px;
        line-height: 18px;
        padding: 1px 8px;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        background: #FAFAFA;
        margin-left: 8px;
        flex-shrink: 0;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    .icon-container {
      display: flex;
      align-items: center;
      color: @text-tag-gery;
      margin: 0 10px;

      .icon-item {
        border-radius: 4px;
        padding: 4px;
        cursor: pointer;

        &:hover {
          background: #DAE0E8;
        }
      }

      .icon-item + .icon-item {
        margin-left: 6px;
      }
    }

    .login-btn-wrapper {
      .el-button {
        height: 28px;
        padding: 0 15px;
      }
    }

    .user-info {
      position: relative;

      .user-brief-info {
        height: 100%;
        cursor: pointer;

        img {
          width: 24px;
          height: 24px;
          border-radius: 16px;
        }

        .user-name {
          display: inline-block;
          font-size: 14px;
          padding-left: 10px;
          line-height: 16px;
          height: 16px;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #282832;
        }
      }

      .user-menu {
        position: absolute;
        right: 0;
        top: 40px;
        border-radius: 2px;
        z-index: 10000;
        background: white;
        color: @color-text-grey-4;
        box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
          0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);

        .user-action {
          margin: 16px 0;
        }

        .user-info-menu-item {
          border-bottom: 1px solid #d2d9e3;
          min-width: 246px;
          min-height: 70px;
          font-size: 14px;
          line-height: 70px;
          padding: 0 16px;
          box-sizing: border-box;

          img {
            position: absolute;
            left: 18px;
            top: 18px;
            width: 40px;
            height: 40px;
            border-radius: 99px;
            opacity: 1;
            display: flex;
            flex-direction: row;
            padding: 0;
          }

          .user-name {
            position: absolute;
            left: 73px;
            top: 18px;
            width: 28px;
            height: 20px;
            opacity: 1;
            font-family: Microsoft YaHei;
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            text-align: left;
            display: flex;
            align-items: center;
            letter-spacing: 0;
            width: 165px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;
            color: #495f70;
          }

          .user-mobile {
            position: absolute;
            left: 73px;
            top: 38px;
            width: 126px;
            height: 20px;
            opacity: 0.65;
            font-family: Microsoft YaHei;
            font-size: 12px;
            font-weight: normal;
            line-height: 20px;
            text-align: center;
            display: flex;
            align-items: center;
            letter-spacing: 0em;
            color: rgba(73, 95, 112, 0.6);
          }
        }

        .user-menu-item {
          min-width: 152px;
          min-height: 40px;
          font-size: 14px;
          line-height: 40px;
          padding: 0 26px;
          box-sizing: border-box;
          text-align: left;
          cursor: pointer;
          display: flex;
          align-items: center;

          &:hover {
            background: @color-fill-background;
            transition: all 0.3s;
          }

          a {
            color: inherit;
            display: flex;
            align-items: center;
          }

          span {
            padding-left: 8px;
          }

          .svg-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}
</style>

